import {Box, InputLabel, MenuItem, Select, Tooltip, Typography} from "@mui/material";
import {memo} from "react";
import {useTheme} from "@mui/material/styles";

const MhdSelect = ({ label, value, override, warning, error, onChange, disabled, choices }) => {
  const theme = useTheme()
  return (
    <>
      <InputLabel variant={error ? 'error' : 'primary'}>
        {label}
      </InputLabel>
      <Tooltip
        title={warning} arrow placement={"top"}
        componentsProps={{
          tooltip: {sx: {backgroundColor: theme.palette.error.main, color: 'white'}},
          arrow: {sx: {color: theme.palette.error.main}},
        }}
      >
        <Select
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          error={!!error}
          disabled={disabled}
          sx={{height: choices[0] && choices[0].secondaryLabel ? '50px' : '30px'}}
        >
        {choices.map((choice) => (
          <MenuItem
            key={choice.value}
            value={choice.value}
            disabled={choice.disabled}
            style={{
              minHeight: choice.secondaryLabel ? '50px' : '30px',
            }}
          >
            <Box>
              <Typography variant='body1'>
                {choice.label}
              </Typography>

              {choice.secondaryLabel && (
                <Typography variant='body2' color='textSecondary'>
                  {choice.secondaryLabel}
                </Typography>
              )}
          </Box>
          </MenuItem>
        ))}
        </Select>
      </Tooltip>
      {(override || warning) &&
        <Typography variant='caption' color='error'>
          Modified: {choices.find((item) => item.value === override)?.label ?? 'None'}
        </Typography>
      }
    </>
  );
};

export default memo(MhdSelect);